import { Icon, TextEllipsis } from '@aibees/shared/components';
import { NotificationMetadataStatus } from '@aibees/shared/features/notifications';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo, useMemo } from 'react';
import { CrawlNotificationActionButton } from '../crawl-notification-action-button';
import * as Styled from './styles';
import * as SX from './sx';
import type { CrawlNotificationActionProps as Props } from './types';

export const CrawlNotificationAction = memo(({ className, item }: Props) => {
  const title = useMemo(() => {
    if (item.message.metadata.status === NotificationMetadataStatus.SUCCESS) {
      return item.message.metadata.name;
    }
    return item.message.metadata.link;
  }, [
    item.message.metadata.link,
    item.message.metadata.name,
    item.message.metadata.status,
  ]);

  if (item.message.metadata.status === NotificationMetadataStatus.PROCESSING) {
    return null;
  }

  return (
    <Styled.Wrapper
      className={classnames('CrawlNotificationAction', className)}
      sx={SX.root}
      variant="outlined"
    >
      <Stack direction="row" alignItems="center" gap={0.5} overflow="hidden">
        <Stack>
          <Icon
            name={
              item.message.metadata.group === 'PERSON' ? 'people' : 'business'
            }
            size={18}
            color="grey.500"
          />
        </Stack>

        <TextEllipsis variant="body3" color="grey.700">
          {title}
        </TextEllipsis>
      </Stack>

      <CrawlNotificationActionButton item={item} />
    </Styled.Wrapper>
  );
});

CrawlNotificationAction.displayName = 'CrawlNotificationAction';
